import { Spin } from "antd";
import styles from "./loading.module.scss";

const Loading = () => {
  return (
    <div className={styles.loadingContainer} data-testid="monitoring-report-uploading">
      <Spin size="small" />
      <span className={styles.uploadingText}>Uploading</span>
    </div>
  );
};

export default Loading;
